import React from 'react';
import { Link } from 'react-router-dom';
import './buttons.css';

const ButtonBlue = ({ destination, text }) => {
	return (
		<div className="center">
      <Link to={destination} className="blue">
        {text}
      </Link>
    </div>
		);
}

export default ButtonBlue;